<template>
  <div class="owned-item-page">
    <div class="page-head">
      <div>
        <h2>私域宇宙自有数据</h2>
        <p>维护名称、分类、性别、图片链接、qiutibili、apmg、运行速度、向右偏移和飞行位置；图片只修改链接，不上传文件。</p>
      </div>
      <el-button icon="el-icon-refresh" :loading="loading" @click="loadData">刷新</el-button>
    </div>

    <div class="category-strip">
      <button
        v-for="item in categoryOptions"
        :key="item.name"
        type="button"
        :class="['category-card', { active: activeCategory === item.name }]"
        @click="activeCategory = item.name"
      >
        <span>{{ item.name }}</span>
        <strong>{{ item.total }}</strong>
      </button>
    </div>

    <div class="table-panel">
      <div class="table-tools">
        <el-input
          v-model.trim="keyword"
          clearable
          prefix-icon="el-icon-search"
          placeholder="搜索名称、分类、图片、qiutibili、apmg、运行速度或向右偏移"
        />
        <span>当前 {{ filteredItems.length }} 条</span>
      </div>

      <el-table
        v-loading="loading"
        :data="pagedItems"
        border
        empty-text="暂无数据"
        style="width: 100%"
      >
        <el-table-column prop="namech" label="名称" min-width="150">
          <template slot-scope="scope">
            <span class="name-cell">{{ scope.row.namech || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sub_category" label="分类" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.sub_category || '成年' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" min-width="90">
          <template slot-scope="scope">
            <span>{{ genderLabel(scope.row.gender) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="飞行位置" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row._category === '飞行器' ? (scope.row.flight_position || '上') : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="right_offset" label="向右偏移" min-width="130">
          <template slot-scope="scope">
            <span class="mono-cell">{{ scope.row.right_offset || '0' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" min-width="320">
          <template slot-scope="scope">
            <div class="image-cell">
              <div class="thumb">
                <img
                  v-if="scope.row.img && !failedImages[scope.row.stat_id]"
                  :src="scope.row.img"
                  :alt="scope.row.namech || '产品图片'"
                  @error="$set(failedImages, scope.row.stat_id, true)"
                >
                <span v-else>{{ scope.row.img ? '无法预览' : '暂无图片' }}</span>
              </div>
              <a
                v-if="isHttpLink(scope.row.img)"
                :href="scope.row.img"
                target="_blank"
                rel="noopener noreferrer"
                class="link-text"
              >{{ scope.row.img }}</a>
              <span v-else class="link-text muted">{{ scope.row.img || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="qiutibili" label="qiutibili" min-width="130">
          <template slot-scope="scope">
            <span class="mono-cell">{{ scope.row.qiutibili || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="apmg" min-width="300">
          <template slot-scope="scope">
            <a
              v-if="isHttpLink(scope.row.apmg)"
              :href="scope.row.apmg"
              target="_blank"
              rel="noopener noreferrer"
              class="link-text"
            >{{ scope.row.apmg }}</a>
            <span v-else class="link-text muted">{{ scope.row.apmg || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="real_speed" label="运行速度" min-width="130">
          <template slot-scope="scope">
            <span class="mono-cell">{{ scope.row.real_speed || '1' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="176" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" plain @click="openEditor(scope.row)">编辑</el-button>
            <el-button
              type="danger"
              size="mini"
              plain
              :loading="deletingStatId === Number(scope.row.stat_id)"
              :disabled="deleteConfirmingStatId !== 0 || (deletingStatId !== 0 && deletingStatId !== Number(scope.row.stat_id))"
              @click="confirmDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-row">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredItems.length"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="currentPage = $event"
        />
      </div>
    </div>

    <el-dialog
      title="编辑自有数据"
      :visible.sync="editorVisible"
      width="680px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" @submit.native.prevent="submitEdit">
        <el-form-item label="名称" required>
          <el-input v-model.trim="form.namech" maxlength="255" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item v-if="form.category === '飞行器'" label="飞行位置">
          <el-select v-model="form.flight_position" style="width: 100%">
            <el-option label="上" value="上" />
            <el-option label="下" value="下" />
            <el-option label="上下" value="上下" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类" required>
          <el-select v-model="form.sub_category" placeholder="请选择分类" style="width: 100%">
            <el-option
              v-for="item in subCategoryOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="性别" required>
          <el-select v-model="form.gender" placeholder="请选择性别" style="width: 100%">
            <el-option label="男" value="male" />
            <el-option label="女" value="female" />
            <el-option label="中性" value="neutral" />
          </el-select>
        </el-form-item>
        <el-form-item label="图片" class="link-form-item">
          <el-input
            v-model.trim="form.img"
            type="textarea"
            :rows="3"
            placeholder="HTTP/HTTPS 图片链接，可留空"
            @input="previewFailed = false"
          />
          <div class="edit-preview">
            <img
              v-if="form.img && !previewFailed"
              :src="form.img"
              alt="图片预览"
              @error="previewFailed = true"
            >
            <span v-else>{{ form.img ? '图片无法预览' : '未填写图片链接' }}</span>
          </div>
        </el-form-item>
        <el-form-item label="qiutibili">
          <el-input
            v-model.trim="form.qiutibili"
            maxlength="255"
            show-word-limit
            placeholder="请输入球体显示比例字符串"
          />
        </el-form-item>
        <el-form-item label="apmg">
          <el-input
            v-model.trim="form.apmg"
            type="textarea"
            :rows="3"
            placeholder="HTTP/HTTPS APMG 链接，可留空"
          />
        </el-form-item>
        <el-form-item label="运行速度" required>
          <el-input
            v-model.trim="form.real_speed"
            maxlength="255"
            show-word-limit
            placeholder="请输入运行速度，默认1"
          />
        </el-form-item>
        <el-form-item label="向右偏移" required>
          <el-input
            v-model.trim="form.right_offset"
            maxlength="255"
            show-word-limit
            placeholder="请输入向右偏移值，默认0"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  createPrivateUniverseOwnedItemApi,
  normalizePrivateUniverseOwnedItemLink
} from '@/api/privateUniverseOwnedItem'

export default {
  name: 'PrivateUniverseOwnedItemAdmin',
  data () {
    return {
      api: null,
      loading: false,
      saving: false,
      deletingStatId: 0,
      deleteConfirmingStatId: 0,
      groups: [],
      activeCategory: '全部',
      keyword: '',
      currentPage: 1,
      pageSize: 20,
      editorVisible: false,
      previewFailed: false,
      failedImages: {},
      subCategoryOptions: ['小IP', 'IP', '小孩', '少年', '成年', '大身高', '巨大身高'],
      form: this.emptyForm()
    }
  },
  computed: {
    allItems () {
      const rows = []
      this.groups.forEach(group => {
        const items = Array.isArray(group.list) ? group.list : []
        items.forEach(item => {
          rows.push(Object.assign({ _category: group.category }, item))
        })
      })
      return rows
    },
    categoryOptions () {
      const options = [{ name: '全部', total: this.allItems.length }]
      this.groups.forEach(group => {
        options.push({ name: group.category, total: Number(group.total || 0) })
      })
      return options
    },
    filteredItems () {
      const keyword = String(this.keyword || '').toLowerCase()
      return this.allItems.filter(item => {
        if (this.activeCategory !== '全部' && item._category !== this.activeCategory) {
          return false
        }
        if (!keyword) {
          return true
        }
        return ['namech', 'sub_category', 'img', 'qiutibili', 'apmg', 'real_speed', 'right_offset'].some(field => {
          return String(item[field] || '').toLowerCase().indexOf(keyword) !== -1
        })
      })
    },
    pagedItems () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredItems.slice(start, start + this.pageSize)
    }
  },
  watch: {
    activeCategory () {
      this.currentPage = 1
    },
    keyword () {
      this.currentPage = 1
    }
  },
  created () {
    if (!window.localStorage.getItem('id')) {
      this.$router.push({ path: '/' })
      return
    }
    this.api = createPrivateUniverseOwnedItemApi(this.$axios)
    this.loadData()
  },
  methods: {
    emptyForm () {
      return { category: '', flight_position: '上', stat_id: 0, namech: '', sub_category: '成年', gender: 'neutral', right_offset: '0', img: '', qiutibili: '', apmg: '', real_speed: '1' }
    },
    genderLabel (value) {
      return { male: '男', female: '女', neutral: '中性' }[value] || '中性'
    },
    loadData () {
      this.loading = true
      this.failedImages = {}
      return this.api.list().then(data => {
        this.groups = data && Array.isArray(data.groups) ? data.groups : []
        const maxPage = Math.max(1, Math.ceil(this.filteredItems.length / this.pageSize))
        this.currentPage = Math.min(this.currentPage, maxPage)
      }).catch(error => {
        this.$message.error(error && error.message ? error.message : '自有数据加载失败')
      }).then(() => {
        this.loading = false
      })
    },
    openEditor (row) {
      this.form = {
        category: row._category,
        flight_position: ['上', '下', '上下'].indexOf(row.flight_position) !== -1 ? row.flight_position : '上',
        stat_id: Number(row.stat_id || 0),
        namech: String(row.namech || ''),
        sub_category: String(row.sub_category || '成年'),
        gender: ['male', 'female', 'neutral'].indexOf(row.gender) !== -1 ? row.gender : 'neutral',
        right_offset: row.right_offset === undefined || row.right_offset === null || String(row.right_offset).trim() === ''
          ? '0'
          : String(row.right_offset),
        img: normalizePrivateUniverseOwnedItemLink(row.img),
        qiutibili: String(row.qiutibili || ''),
        apmg: normalizePrivateUniverseOwnedItemLink(row.apmg),
        real_speed: row.real_speed === undefined || row.real_speed === null || String(row.real_speed).trim() === ''
          ? '1'
          : String(row.real_speed)
      }
      this.previewFailed = false
      this.editorVisible = true
    },
    submitEdit () {
      const errorMessage = this.validateForm()
      if (errorMessage) {
        this.$message.warning(errorMessage)
        return
      }
      this.saving = true
      return this.api.update({
        stat_id: this.form.stat_id,
        namech: this.form.namech,
        img: this.form.img,
        qiutibili: this.form.qiutibili,
        apmg: this.form.apmg,
        real_speed: this.form.real_speed,
        sub_category: this.form.sub_category,
        gender: this.form.gender,
        right_offset: this.form.right_offset,
        flight_position: this.form.category === '飞行器' ? this.form.flight_position : undefined
      }).then(result => {
        const count = result && Number(result.updated_snapshot_count || 0)
        this.$message.success('保存成功，已同步 ' + count + ' 条统计快照')
        this.editorVisible = false
        return this.loadData()
      }).catch(error => {
        this.$message.error(error && error.message ? error.message : '保存失败，请稍后重试')
      }).then(() => {
        this.saving = false
      })
    },
    confirmDelete (row) {
      if (this.deletingStatId !== 0 || this.deleteConfirmingStatId !== 0) {
        return
      }
      const statId = Number(row && row.stat_id ? row.stat_id : 0)
      if (statId <= 0) {
        this.$message.warning('统计记录ID无效')
        return
      }
      const name = String(row.namech || '未命名数据')
      this.deleteConfirmingStatId = statId
      return this.$confirm(
        '确定删除“' + name + '”吗？删除后不可恢复。',
        '删除确认',
        {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        }
      ).then(() => {
        this.deleteConfirmingStatId = 0
        this.deletingStatId = statId
        return this.api.remove(statId)
      }).then(() => {
        this.$message.success('删除成功')
        return this.loadData()
      }).catch(reason => {
        if (reason !== 'cancel' && reason !== 'close') {
          this.$message.error(reason && reason.message ? reason.message : '删除失败，请稍后重试')
        }
      }).then(() => {
        this.deletingStatId = 0
        this.deleteConfirmingStatId = 0
      })
    },
    validateForm () {
      if (!String(this.form.namech || '').trim()) {
        return '名称不能为空'
      }
      if (this.subCategoryOptions.indexOf(this.form.sub_category) === -1) {
        return '分类值无效'
      }
      if (['male', 'female', 'neutral'].indexOf(this.form.gender) === -1) {
        return '性别值无效'
      }
      if (this.form.img && !this.isHttpLink(this.form.img)) {
        return '图片必须为 HTTP/HTTPS 链接'
      }
      if (String(this.form.qiutibili || '').length > 255) {
        return 'qiutibili 不能超过255个字符'
      }
      if (this.form.apmg && !this.isHttpLink(this.form.apmg)) {
        return 'apmg 必须为 HTTP/HTTPS 链接'
      }
      if (!String(this.form.real_speed || '').trim()) {
        return '运行速度不能为空'
      }
      if (String(this.form.real_speed || '').length > 255) {
        return '运行速度不能超过255个字符'
      }
      if (!String(this.form.right_offset || '').trim()) {
        return '向右偏移值不能为空'
      }
      if (String(this.form.right_offset || '').length > 255) {
        return '向右偏移值不能超过255个字符'
      }
      return ''
    },
    isHttpLink (value) {
      return /^https?:\/\/[^/\s?#]+(?:[/?#]\S*)?$/i.test(String(value || '').trim())
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
.owned-item-page {
  min-height: 100vh;
  padding: 24px;
  background: #f3f6fa;
  box-sizing: border-box;
}

.owned-item-page * {
  box-sizing: border-box;
}

.page-head,
.table-panel {
  padding: 20px 22px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left: 5px solid #409eff;
}

.page-head h2 {
  margin: 0;
  color: #1f2d3d;
}

.page-head p {
  margin: 8px 0 0;
  color: #8492a6;
  font-size: 14px;
}

.category-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0;
}

.category-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 142px;
  padding: 14px 16px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
  color: #606266;
  cursor: pointer;
}

.category-card strong {
  margin-left: 20px;
  color: #409eff;
  font-size: 20px;
}

.category-card.active {
  border-color: #409eff;
  background: #ecf5ff;
  color: #409eff;
}

.table-tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  color: #909399;
}

.table-tools .el-input {
  width: 420px;
}

.name-cell {
  color: #303133;
  font-weight: 600;
}

.image-cell {
  display: flex;
  align-items: center;
  min-width: 0;
}

.thumb,
.edit-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f2f6fc;
  color: #909399;
}

.thumb {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  margin-right: 12px;
  border-radius: 6px;
  font-size: 12px;
}

.thumb img,
.edit-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.link-text {
  display: block;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link-text.muted {
  color: #909399;
}

.mono-cell {
  font-family: Consolas, monospace;
}

.pagination-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.edit-preview {
  width: 180px;
  height: 140px;
  margin-top: 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
}

@media (max-width: 900px) {
  .owned-item-page {
    padding: 14px;
  }

  .page-head,
  .table-tools {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .table-tools .el-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/privateUniverseOwnedItem.vue